import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sig-pad__frame" }
const _hoisted_2 = {
  key: 0,
  class: "sig-pad__placeholder",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "sig-pad__tools" }

import { onMounted, onUnmounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignaturePad',
  props: {
    size: { default: 'lg' }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit

const canvasRef = ref<HTMLCanvasElement | null>(null)
const empty = ref(true)
let drawing = false
let ctx: CanvasRenderingContext2D | null = null
let savedDataUrl = ''

function resize(preserve = true) {
  const canvas = canvasRef.value
  if (!canvas) return
  const keep = preserve && !empty.value ? canvas.toDataURL('image/png') : ''
  const ratio = window.devicePixelRatio || 1
  const width = canvas.clientWidth
  const height = canvas.clientHeight
  canvas.width = Math.floor(width * ratio)
  canvas.height = Math.floor(height * ratio)
  ctx = canvas.getContext('2d')
  if (!ctx) return
  ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
  ctx.lineWidth = 2.8
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.strokeStyle = '#1b1f24'
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, width, height)

  if (keep) {
    const img = new Image()
    img.onload = () => {
      if (!ctx) return
      ctx.drawImage(img, 0, 0, width, height)
      empty.value = false
      savedDataUrl = keep
      emit('change', keep)
    }
    img.src = keep
    return
  }

  empty.value = true
  savedDataUrl = ''
  emit('change', '')
}

function point(event: PointerEvent) {
  const canvas = canvasRef.value
  if (!canvas) return { x: 0, y: 0 }
  const rect = canvas.getBoundingClientRect()
  return { x: event.clientX - rect.left, y: event.clientY - rect.top }
}

function onDown(event: PointerEvent) {
  if (!ctx) return
  event.preventDefault()
  drawing = true
  canvasRef.value?.setPointerCapture(event.pointerId)
  const p = point(event)
  ctx.beginPath()
  ctx.moveTo(p.x, p.y)
}

function onMove(event: PointerEvent) {
  if (!drawing || !ctx) return
  event.preventDefault()
  const p = point(event)
  ctx.lineTo(p.x, p.y)
  ctx.stroke()
  empty.value = false
}

function onUp() {
  if (!drawing) return
  drawing = false
  emitChange()
}

function emitChange() {
  const canvas = canvasRef.value
  if (!canvas || empty.value) {
    savedDataUrl = ''
    emit('change', '')
    return
  }
  savedDataUrl = canvas.toDataURL('image/png')
  emit('change', savedDataUrl)
}

function clear() {
  resize(false)
}

function onWindowResize() {
  resize(true)
}

onMounted(() => {
  resize(false)
  window.addEventListener('resize', onWindowResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', onWindowResize)
})

__expose({ clear, isEmpty: () => empty.value })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sig-pad", `sig-pad--${__props.size}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        class: "sig-pad__canvas",
        onPointerdown: onDown,
        onPointermove: onMove,
        onPointerup: onUp,
        onPointerleave: onUp,
        onPointercancel: onUp
      }, null, 544),
      (empty.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 마우스나 손가락으로 서명해 주세요 "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "sui-btn sui-btn--sm",
        onClick: clear
      }, "지우기"),
      _createElementVNode("span", {
        class: _normalizeClass(["sig-pad__status", { 'is-done': !empty.value }])
      }, _toDisplayString(empty.value ? '서명이 비어 있습니다' : '서명 입력됨'), 3)
    ])
  ], 2))
}
}

})